import React from "react";
import { LinearProgress } from "@material-ui/core";
import { ProgressBarProperties } from "./ProgressBarProperties";
import './ProgressBar.scss';

export const ProgressBar: React.FC<ProgressBarProperties> = (props) => (
  <div className="progress-bar-container">
    <LinearProgress value={props.value} variant="determinate" />
  </div>
);
